// extracted by mini-css-extract-plugin
module.exports = {"m285iru":"m285iru","tabs":"tabs","content":"content","bordered":"bordered","sticky":"sticky"};